export enum LANG {
  EN = 'EN',
  ID = 'ID',
  VN = 'VN',
  CN = 'CN',
  TH = 'TH',
  MY = 'MY',
}

export const DEFAULT_LANG = LANG.EN;
